<template>
<div>
<div class="row ">
    <div class="col-12">
        <label class="form-label">Gift card’s value</label>
    </div>
</div>
<div v-if="this.card_values" class="row mt-2" v-for="(item,index) in this.card_values">
    <div class="col-10">
        <input class="form-control"
               placeholder="Card’s value"
               v-model="item.value" name="gift_card_values[]"
               @keydown="$event.keyCode === 13 ? $event.preventDefault() : false"
               type="number"
        />
    </div>
    <div class="col-2 d-flex justify-content-center">
        <a class="btn btn-square btn-danger rounded-circle" @click="removeCardRate(index)">
            <span class="svg-icon">
                <i class="bi bi-archive-fill"></i>
            </span>
        </a>
    </div>
</div>
<div class="row mt-2">
    <div class="col-md-2">
        <button type="button" class="btn btn-custom-primary" @click="addCardRate">New
        </button>
    </div>
</div>
</div>
</template>

<script>
export default {
    props: {
        old: Array
    },
    components: {}
    ,
    data: function () {
        return {
            card_values: [],
        }
    },
    methods: {
        addCardRate() {
            this.card_values.push({
                id: this.card_values.length + 1,
                rate: ''
            });
        },
        removeCardRate(index) {
            this.card_values.splice(index, 1);
        }
    },
    mounted() {
        if (this.old.length !== 0) {
            this.card_values = [];//empty array
            let index = 0;
            this.old.forEach(
                el => {
                    let amount = typeof el.value === 'undefined' ? el : el.value
                    this.card_values.push({value: amount});
                    index++;
                }
            );
        }
    }
}
</script>

